module.exports = __webpack_public_path__ + "img/Weapon_40.2b71f0f9.png";